import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { SocketService } from '../shared/services/socket.service';
import { Message } from '../shared/model/message';
import { GameStatus } from '../shared/model/game-status';
import { MessageType } from '../shared/model/message-type';
import { User } from '../shared/model/user';
import { getServerUrl } from '../shared/utils/utils';
import * as NoSleep from 'nosleep.js';

@Component({
  selector: 'pbg-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit, OnDestroy {
  ioConnection: any;
  showReady = false;
  showWaiting = false;
  waitMode = false;
  gameId = '';
  randomId = '';
  user: User = {};
  startingScore = 0;
  noSleep: any;
  disconnected = false;

  constructor(
    public socketService: SocketService,
    public cookieService: CookieService,
    public router: Router,
    public resolver: ActivatedRoute
  ) {
    try {
      this.noSleep = new NoSleep();
    } catch (e) {
      console.log(e);
    }
  }

  ngOnInit() {
    if (this.isValidUser() && this.isValidGame()) {
      this.initGame();
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy() {
    try {
      this.allowSleep(false);
      this.socketService.close();
    } catch (e) {
      // There is no socket to close.
    }

    this.clean();
  }

  clean() {}

  allowSleep(allow = false) {
    try {
      if (allow) {
        this.noSleep.enable();
      } else {
        this.noSleep.disable();
      }
    } catch (e) {
      console.log(e);
    }
  }

  isValidUser(): boolean {
    return this.cookieService.check('username') && this.cookieService.check('userId');
  }

  isValidGame(): boolean {
    // TODO: Check with server to determine that gameID exists and is still active.
    console.log('Resolver:');
    console.log(this.resolver.snapshot.data);
    console.log(this.resolver.snapshot.data.gameExists);
    return this.resolver.snapshot.data.gameExists.success;
  }

  initIoConnection(): void {
    this.socketService.initSocket(getServerUrl(this.gameId));

    this.ioConnection = this.socketService.onMessage().subscribe((message: any) => {
      console.log('Message being received is...');
      console.log(message);
      if (
        (message.action === MessageType.Ready && message.to === this.user.name) ||
        (message.action === MessageType.Waiting &&
          message.content.firstConnected === this.user.name)
      ) {
        this.showReady = true;
        this.showWaiting = false;
      } else if (message.action === MessageType.Waiting && !this.showReady) {
        this.showReady = false;
        this.showWaiting = true;
      } else if (
        message.action === MessageType.Question ||
        message.action === MessageType.Prompt
      ) {
        this.showReady = false;
        this.showWaiting = false;
      } else if (message.action === MessageType.Host) {
        this.hostMessageHandler(message);
      }

      if (message.action && message.content) {
        this.messageHandler(message);
      }
      console.log(' ------ ');
    });

    this.socketService.onDisconnect().subscribe(status => {
      this.disconnected = status.disconnected || false;
    });

    this.socketService.onReconnect().subscribe(status => {
      if (!status.disconnected && this.disconnected) {
        console.trace();
        this.sendNotification(MessageType.Connected);
        this.disconnected = false;
      }
    });

    this.socketService.onEvent(MessageType.Connected).subscribe(() => {
      console.log('connected');
    });

    this.socketService.onEvent(MessageType.Disconnected).subscribe(() => {
      console.log('disconnected');
    });
  }

  hostMessageHandler(message: Message) {
    if (message.content.status === GameStatus.Complete) {
      this.router.navigate(['/login']);
    } else if (message.content.status === GameStatus.InProgress) {
      this.showReady = false;
      this.showWaiting = false;
    }
  }

  onReadyHandler() {
    this.socketService.send({
      from: this.user,
      content: '',
      action: MessageType.Ready,
      gameId: this.gameId
    });

    this.showReady = false;
    this.showWaiting = true;
  }

  initGame(): void {
    this.allowSleep(true);
    this.user.name = this.cookieService.get('username');
    this.randomId = this.cookieService.get('userId');
    this.gameId = this.cookieService.get('gameId');
    this.user.avatar = `https://api.adorable.io/avatars/100/${this.randomId}.png`;
    this.user.currentScore = this.startingScore;
    this.initIoConnection();
    this.sendNotification(MessageType.Connected);
  }

  sendNotification(action: MessageType): void {
    let message: Message;

    message = {
      from: this.user,
      content: this.gameId,
      action: action,
      gameId: this.gameId
    };

    this.socketService.send(message);
  }

  // Extendable Functions
  messageHandler(message: Message) {}
}
